// Mengubah teks (soal/balasan TAKA) menjadi kalimat yang enak dibacakan mesin suara
// berbahasa Indonesia. Angka dibiarkan apa adanya (mesin suara id-ID sudah membacanya
// dengan benar); yang diubah adalah simbol matematika, satuan, dan format khusus.
const SATUAN = [
  [/\bcm²/g, 'sentimeter persegi'], [/\bm²/g, 'meter persegi'], [/\bkm²/g, 'kilometer persegi'],
  [/\bcm³/g, 'sentimeter kubik'], [/\bm³/g, 'meter kubik'], [/\bdm³/g, 'desimeter kubik'],
  [/\bkm\/jam\b/g, 'kilometer per jam'], [/\bm\/detik\b/g, 'meter per detik'],
  [/(\d)\s?km\b/g, '$1 kilometer'], [/(\d)\s?hm\b/g, '$1 hektometer'], [/(\d)\s?dam\b/g, '$1 dekameter'], [/(\d)\s?dm\b/g, '$1 desimeter'],
  [/(\d)\s?cm\b/g, '$1 sentimeter'], [/(\d)\s?mm\b/g, '$1 milimeter'], [/(\d)\s?m\b/g, '$1 meter'],
  [/(\d)\s?kg\b/g, '$1 kilogram'], [/(\d)\s?hg\b/g, '$1 hektogram'], [/(\d)\s?dag\b/g, '$1 dekagram'], [/(\d)\s?mg\b/g, '$1 miligram'], [/(\d)\s?g\b/g, '$1 gram'],
  [/(\d)\s?kl\b/g, '$1 kiloliter'], [/(\d)\s?hl\b/g, '$1 hektoliter'], [/(\d)\s?dal\b/g, '$1 dekaliter'], [/(\d)\s?ml\b/g, '$1 mililiter'], [/(\d)\s?l\b/g, '$1 liter'],
  [/(\d)\s?dtk\b/g, '$1 detik'], [/(\d)\s?mnt\b/g, '$1 menit'],
];

export function teksUntukSuara(teks) {
  let t = String(teks ?? '');
  t = t.replace(/<[^>]*>/g, ' ').replace(/&nbsp;|&#8239;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  t = t.replace(/\*\*(.+?)\*\*/g, '$1').replace(/[*_#`]/g, '');
  // Uang: Rp24.000,00 -> 24.000 rupiah
  t = t.replace(/Rp\s?([\d.]+)(,00)?/g, '$1 rupiah');
  // Jam: pukul 07.45 -> pukul 7 lewat 45 ; pukul 08.00 -> pukul 8
  t = t.replace(/\b(pukul|jam)\s+0?(\d{1,2})[.:](\d{2})\b/gi, (_, k, h, m) => `${k} ${+h}${m === '00' ? '' : ` lewat ${+m}`}`);
  // Pecahan campuran dan biasa: 2 1/4 -> 2 dan 1 per 4 ; 3/4 -> 3 per 4
  t = t.replace(/\b(\d+)\s+(\d+)\/(\d+)\b/g, '$1 dan $2 per $3');
  t = t.replace(/\b(\d+)\/(\d+)\b/g, '$1 per $2');
  // Operasi hitung di antara angka/kata: × : − + =
  t = t.replace(/\s*[×x]\s*(?=\d|\()/g, ' kali ').replace(/(\d)\s*×/g, '$1 kali ');
  t = t.replace(/(\d)\s*:\s*(\d)/g, '$1 dibagi $2');
  t = t.replace(/([\d°%])\s*[−–-]\s*(\d)/g, '$1 kurang $2');
  t = t.replace(/\s*\+\s*/g, ' tambah ');
  t = t.replace(/\s*=\s*/g, ' sama dengan ');
  // Derajat dan persen
  t = t.replace(/(\d)\s?°/g, '$1 derajat').replace(/(\d)\s?%/g, '$1 persen');
  for (const [p, g] of SATUAN) t = t.replace(p, g);
  t = t.replace(/\s*→\s*/g, ', jadi ').replace(/[<>]/g, ' ').replace(/\?{2,}/g, '?');
  t = t.replace(/\s*(\.{3,}|…)/g, ' titik-titik').replace(/\s+/g, ' ').trim();
  return t;
}

// Pecah teks menjadi potongan pendek (Chrome kadang berhenti membacakan kalimat panjang).
export function potongKalimat(teks, maks = 180) {
  const kalimat = String(teks).match(/[^.!?]+[.!?]*/g) || [];
  const out = [];
  for (let k of kalimat.map(s => s.trim()).filter(Boolean)) {
    while (k.length > maks) {
      const i = k.lastIndexOf(' ', maks);
      out.push(k.slice(0, i > 40 ? i : maks).trim());
      k = k.slice(i > 40 ? i : maks).trim();
    }
    if (k) out.push(k);
  }
  return out;
}
